import TheoryReviewPage from './theory-review-page'

export default TheoryReviewPage
